function initSliderAnimations() {
  const sliders = document.querySelectorAll(".mm-marquee");
  const speedFactor = 0.1; // Ajuste cette valeur pour modifier la vitesse

  if (sliders.length === 0) return;

  sliders.forEach((slider) => {
    const wrapper = slider.querySelector(".mm-wrapper-marquee");

    if (!wrapper) return;

    const content = wrapper.innerHTML;
    wrapper.innerHTML += content + content;

    // Appliquer une opacité alternée aux enfants
    const items = wrapper.children;
    Array.from(items).forEach((item, index) => {
      item.style.opacity = index % 2 === 0 ? "1" : "0.3";
    });

    gsap.to(wrapper, {
      x: `-${wrapper.scrollWidth / 3}px`,
      ease: "none",
      scrollTrigger: {
        trigger: slider,
        start: "bottom bottom",
        end: "top top",
        scrub: speedFactor, // Contrôle la vitesse du scroll
      },
    });
  });
}

document.addEventListener("DOMContentLoaded", initSliderAnimations);
